import { Grid, TextField, Typography } from "@mui/material";
import { PlanningAppealsSearchState } from "./PlanningAppealsSearchState";
import "../Search.css";
import { PlanningAppealsFilter } from "@shared/publicportal/contracts/PlanningAppealsFilter";

interface PlanningAppealsSimpleSearchProps {
    state: PlanningAppealsSearchState;
    setter: (modifier: Partial<PlanningAppealsFilter>) => void;
}

const PlanningAppealsSimpleSearch: React.FC<PlanningAppealsSimpleSearchProps> = (props) => {
    if (props.state.searchType === "Advanced") {
        return (
            <Grid container className="search-container search-container-simple" sx={{ width: { sm: "100%", md: "80%", lg: "60%", xl: "70%" } }}>
                {getContent()}
            </Grid>
        );
    }
    return (
        <>
            <Grid container className="search-container search-container-simple">
                {getContent()}
            </Grid>
        </>
    );

    function getContent() {
        return (
            <>
                <Grid size={{ xs: 12, md: 12, xl: 12 }}>
                    <Typography variant="h5">Reference</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: props.state.searchType === "Advanced" ? 6 : 12, xl: props.state.searchType === "Advanced" ? 4 : 12 }}>
                    <TextField
                        name="appealRef"
                        value={props.state.filter.appealRef}
                        onChange={(event) => props.setter({ appealRef: event.target.value })}
                        key="appeal-Appeal-Reference-key"
                        size="small"
                        id="appeal-Appeal-Reference"
                        label="Appeal Reference"
                        variant="outlined"
                        className="min-width-18rem"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: props.state.searchType === "Advanced" ? 6 : 12, xl: props.state.searchType === "Advanced" ? 4 : 12 }}>
                    <TextField
                        value={props.state.filter.applicationRef}
                        onChange={(event) => props.setter({ applicationRef: event.target.value })}
                        key="appeal-Application-Reference-key"
                        size="small"
                        id="appeal-Application-Reference"
                        label="Application Reference"
                        variant="outlined"
                        className="min-width-18rem"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: props.state.searchType === "Advanced" ? 6 : 12, xl: props.state.searchType === "Advanced" ? 4 : 12 }}>
                    <TextField
                        value={props.state.filter.planningInspectorateRef}
                        onChange={(event) => props.setter({ planningInspectorateRef: event.target.value })}
                        key="appeal-Planning-Inspectorate-Reference-key"
                        size="small"
                        id="appeal-Planning--InspectorateReference"
                        label="Planning Inspectorate Reference"
                        variant="outlined"
                        className="min-width-18rem"
                    />
                </Grid>
            </>
        );
    }
};

export default PlanningAppealsSimpleSearch;
